export default remote => ({
    autocomplete: (term, data) => remote.get(`flight/aircompany/autocomplete/${ term }`, { params: data }),
    getFromCode : (code) => remote.get(`flight/aircompany/from-code/${ code }`),
    getFromSlug : (slug) => remote.get(`flight/aircompany/from-slug/${ slug }`),
    getAll : (slug) => remote.get(`flight/aircompany/all`)
});
